var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$wait.is(_vm.name) || _vm.icon)?_c('span',{class:[_vm.cls || 'icon']},[(_vm.$wait.is(_vm.name))?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"})]):_vm._e(),_vm._v(" "),(!_vm.$wait.is(_vm.name) && _vm.icon)?_c('i',{class:['fi', _vm.icon]}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }